import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { factions } from '../../../../../shared/action/ActionModel';
import { formatTreeParameter } from "../../../../../shared/helper/actionTreeHelper";
import { Dropdown } from "../../../editor/Dropdown";
import { isBlank } from "../../../../../shared/helper/generalHelpers";
import { ElementGroup, ElementLabel } from './BaseElements';
export const FactionSelectionActionDetail = observer(({
  parentTree,
  name,
  value,
  valueSetter,
  allowBlankValue
}) => {
  const {
    t
  } = useTranslation();
  const parameters = parentTree.treeParameterActions("actions/FactionValueModel").map(p => formatTreeParameter(p.name));
  const options = ["", ...factions, ...parameters];
  const optionsLiterals = ["", ...factions.map(f => t("content.faction_" + f)), ...parameters];
  return /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(ElementLabel, null, name), /*#__PURE__*/React.createElement(Dropdown, {
    className: !allowBlankValue && isBlank(value) ? "invalid" : "",
    value: value,
    onChange: ({
      target
    }) => valueSetter(target.value)
  }, options.map((o, index) => /*#__PURE__*/React.createElement("option", {
    key: o,
    value: o
  }, optionsLiterals[index]))));
});